import { render, staticRenderFns } from "./NewCriticism.vue?vue&type=template&id=2c11c6ab"
import script from "./NewCriticism.vue?vue&type=script&lang=js"
export * from "./NewCriticism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports